import React, { useState } from "react";
import { Link } from "react-router-dom";

import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";
import Switcher from "../../../components/switcher";


import ScrollToTop from "../../../components/scroll-to-top";


export default function Terms() {

  return (
    <>
      <Navbar navClass="defaultscroll is-sticky" />
      <section className="relative table w-full py-32 lg:py-40 bg-gray-50 dark:bg-slate-800">
        <div className="container relative">
          <div className="grid grid-cols-1 text-center mt-10">
            <h3 className="text-3xl leading-normal font-semibold">Terms & Conditions</h3>
            <p1>Review our Terms & Conditions to understand the rules and guidelines that govern your use of our platform.</p1>
          </div>
        </div>

        <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
          <ul className="tracking-[0.5px] mb-0 inline-block">
            <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500"><Link to="/">Sportyfi</Link></li>
            <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
            <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500"><Link to="">Policies</Link></li>
            <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
            <li className="inline-block uppercase text-[13px] font-bold text-orange-500" aria-current="page">Terms & Conditions</li>
          </ul>
        </div>
      </section>
      <section className="relative md:py-24 py-16">
        <div className="container relative">
          <div className="md:flex justify-center">
            <div className="md:w-3/4">
              <div className="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-md">

                <p3 className="text-black-400">Welcome to Sportyfi (https://www. Sportyfi.in/). By accessing and using our website, you agree to comply with and be bound by the following terms and conditions. Please read them carefully before using our site or placing an order.</p3>

                <h5 className="text-xl font-semibold mb-4 mt-8">1. General :</h5>
                <p3 className="text-Black-400">These Terms & Conditions apply to all visitors, users, and customers of our website. Sportyfi reserves the right to update or change these terms at any time without prior notice.</p3>
                {/* <p className="text-slate-400 mt-3">There is now an <b className="text-red-600">abundance</b> of readable dummy texts. These are usually used when a text is <b className="text-red-600">required purely</b> to fill a space. These alternatives to the classic Lorem Ipsum texts are often amusing and tell short, funny or <b className="text-red-600">nonsensical</b> stories.</p>
                            <p className="text-slate-400 mt-3">It seems that only <b className="text-red-600">fragments</b> of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text.</p> */}

                <h5 className="text-xl font-semibold mb-4 mt-8">2. Eligibility:</h5>
                <p className="text-black-400">By using this website, you represent that you are at least 18 years old or are using it under the supervision of a parent or guardian. If you do not meet these requirements, please do not use our website.</p>


                <h5 className="text-xl font-semibold mt-8">3. Products and Orders:</h5>
                <ul className="list-disc pl-6 space-y-2">
                  <li>All products listed are subject to availability.</li>
                  <li>
                    We reserve the right to modify product descriptions, prices, and
                    availability at any time without prior notice.
                  </li>
                  <li>
                    After placing an order, you will receive an order confirmation via
                    email. Please note that this confirmation does <strong>not</strong>{" "}
                    constitute acceptance of your order.
                  </li>
                  <li>
                    Acceptance of your order occurs only when the product is shipped.
                  </li>
                  <li>
                    We reserve the right to cancel or refuse any order at our discretion,
                    including but not limited to cases involving pricing errors, product
                    availability issues, or suspicious transactions.
                  </li>
                </ul>


                <h2 className="text-2xl font-semibold mb-4 mt-8 text-gray-900">
                  4. Pricing and Payment
                </h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    All prices on the website are in Indian Rupees (INR) and inclusive of
                    applicable taxes unless stated otherwise.
                  </li>
                  <li>
                    We accept payments via secure payment gateways including{" "}
                    <strong>Razorpay, UPI, Net Banking,</strong> and{" "}
                    <strong>credit/debit cards</strong>.
                  </li>
                  <li>
                    We do not store your payment information on our servers.
                  </li>
                </ul>
                <h2 className="text-2xl font-semibold mb-4 mt-8 text-gray-900">
                  5. Intellectual Property
                </h2>
                <p>
                  All content on this website – including images, logos, designs, text,
                  and graphics – is the property of <strong>Sportyfi</strong> and is
                  protected by copyright and trademark laws. You may not use, reproduce,
                  or distribute our content without written permission.
                </p>



                <h2 className="text-2xl font-semibold mb-4 mt-8 text-gray-900">
                  6. User Conduct
                </h2>
                <p className="mb-3">You agree not to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Use the site for unlawful or fraudulent purposes.</li>
                  <li>Interfere with the website’s operations or security.</li>
                  <li>Post or transmit any harmful or abusive content.</li>
                </ul>
                <p className="mt-4">
                  We reserve the right to terminate your access for violating these terms.
                </p>

                {/* Section 7 */}
                <h2 className="text-2xl font-semibold mb-4 mt-8 text-gray-900">
                  7. Limitation of Liability
                </h2>
                <p className="mb-8">
                  <strong>Sportyfi</strong> shall not be liable for any direct,
                  indirect, incidental, or consequential damages arising from the use or
                  inability to use our site, products, or services.
                </p>

                {/* Section 8 */}
                <h2 className="text-2xl font-semibold mb-4 mt-8 text-gray-900">
                  8. Governing Law
                </h2>
                <p className="mb-8">
                  These terms shall be governed by the laws of India. Any disputes shall
                  be subject to the exclusive jurisdiction of the courts in{" "}
                  <strong>Bhubaneswar, Odisha</strong>.
                </p>

                {/* Section 9 */}
                <h2 className="text-2xl font-semibold mb-4 mt-8 text-gray-900">
                  9. Contact Us
                </h2>
                <p className="mb-2">
                  For any queries, please reach out to us at:
                </p>
                <ul className="list-none pl-0 space-y-1">
                  <li>
                    <strong>Sportyfi</strong> – Modest Fashion Redefined
                  </li>
                  <li>
                    <strong>Email:</strong> Sportyfi@gmail.com
                  </li>
                  <li>
                    <strong>Location:</strong> Sambit Villa, Ghatikia, Bhubaneswar, India
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Switcher />
      <ScrollToTop />
    </>
  )
}